function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { openWriteToUs } from "@common/actions";
import { replaceWith } from "@common/services/helpers";
import { AUTH_BACK_LINK } from "@config/constants";
export var PostForgottenPasswordRequest = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(PostForgottenPasswordRequest, PureComponent);
    var _super = _create_super(PostForgottenPasswordRequest);
    function PostForgottenPasswordRequest(props) {
        _class_call_check(this, PostForgottenPasswordRequest);
        var _this;
        _this = _super.call(this, props);
        _this.mailUsButton = null;
        _this.openMailUsPopup = _this.openMailUsPopup.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(PostForgottenPasswordRequest, [
        {
            /**
     * Opens the 'mail us' popup.
     */ key: "openMailUsPopup",
            value: function openMailUsPopup() {
            // TODO: open the popup.
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var i18n = this.props.i18n;
                var _i18n_common_brand;
                // Make the 'elemental.tv' link active in the translated string.
                var elementalLink = '<a href="'.concat(AUTH_BACK_LINK, '" class="translation-active">').concat((_i18n_common_brand = i18n.common.brand) !== null && _i18n_common_brand !== void 0 ? _i18n_common_brand : i18n.common.elemental, "</a>");
                var headlineHtml = {
                    __html: replaceWith(i18n.authentication.emailChangePassword, elementalLink)
                };
                // Make the 'Important: ' part of the body string 'bold'.
                var boldImportant = '<span class="translation-bold">'.concat(i18n.common.important, "</span>");
                var importantHtml = {
                    __html: replaceWith(i18n.authentication.emailNotReceivedWarn, boldImportant)
                };
                // Make the 'mail us' part active (a button).
                var mailUsButtonHTML = '<button type="button" class="translation-active">\n                                        <span class="icon icon-contact-us"></span>\n                                        <span class="label">'.concat(i18n.common.mailUs, ".</span>\n                                  </button>");
                var problemNode = /*#__PURE__*/ _jsx("span", {
                    ref: function(el) {
                        return el && (_this.mailUsButton = el.children[0]);
                    },
                    dangerouslySetInnerHTML: {
                        __html: replaceWith(i18n.authentication.mailOnProblem, mailUsButtonHTML)
                    }
                });
                return /*#__PURE__*/ _jsxs("div", {
                    className: "post-forgotten-password-request-component",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "post-headline margin-bottom-small",
                            dangerouslySetInnerHTML: headlineHtml
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "post-body margin-bottom-small",
                            children: i18n.authentication.emailOpenAndClick
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "post-important",
                            dangerouslySetInnerHTML: importantHtml
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "post-problem",
                            children: problemNode
                        })
                    ]
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.mailUsButton && this.mailUsButton.addEventListener("click", this.props.openWriteToUs);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mailUsButton && this.mailUsButton.removeEventListener("click", this.props.openWriteToUs);
            }
        }
    ]);
    return PostForgottenPasswordRequest;
}(PureComponent);
export default connect(null, {
    openWriteToUs: openWriteToUs
})(PostForgottenPasswordRequest);
